<div class="padding-y-4">
  <div class="grid-row grid-gap">
    <div class="grid-col-12">
      @if (extendedStorage === false) {
        <h5>HHG Query Results</h5>
      }
      @if (extendedStorage === true) {
        <h5>XTOS Query Results</h5>
      }
      @if (hhgRateQueryResults && (hhgRateQueryResults.length <= 0)) {
        <div>
          <p class="define-text-color-no-records">
            There are no records to present.
          </p>
        </div>
      }
      @if (hhgRateQueryResults && (hhgRateQueryResults.length > 0)) {
        <div>
          @if (showComments && this.sroType !== 'Extended Storage' && !isInternational) {
            <p class="define-text-color-message">
              Estimated Surface Charges shown below include the Base Linehaul Charge, Origin/Destination Linehaul Factors,
              Origin/Destination Service Charges (OSC/DSC) and Full Pack and Full Unpack charges. OSC/DSC charges include
              elevator service, stair and excess distance carries and ATC charges.
              TSP's may not charge separately for services already included in the OSC/DSC.
              The Base Linehaul Charge includes a 5% bump to cover other accessorial services that may be needed in addition
              to those already included in the OSC/DSC. If using the estimated Surface Charge for comparison purposes,
              deduct the 5% to get a more accurate estimated Surface Charge cost.
              <br />
            </p>
          }
          <p class="define-text-color-no-records">Rate effectivity dates: {{hhgRateQueryResults[0]?.effectiveDate ?
            (hhgRateQueryResults[0]?.effectiveDate | date:'mediumDate':'UTC') : ''}} - {{hhgRateQueryResults[0] ?
            (hhgRateQueryResults[0]?.expiryDate | date:'mediumDate':'UTC') : ''}}. Rate type : G - General Transportation.
            @if (this.sroType !== 'Extended Storage') {
              <span>
                M - Move Management Services.
                <span class="new-carrier"> New TSPs are listed in blue.</span>
                <span class="vi-100-above-carrier"> Value Index greater than 100 are listed in green.</span>
                <span class="vi-100-less-carrier"> Others are listed in yellow.</span>
              </span>
            }
          </p>
          <!--<p style="color: #8F0808">Rate effectivity dates: May 1, 2019 - Dec 31, 2019 * - Indicates agency specific rate. G:General Transportation. M: Move Management Services.</p>-->
          <p class="define-text-color-no-records">
            Socio Economic Indicator:
            s - Small Business, o - Other than Small Business, w - Woman Owned Business, v - Veteran Owned Small Business,
            dv - Service Disabled Veteran Owned Small Business ,
            d - SBA Certified Small Disadvantaged Business, 8a - SBA Certified 8(a) firm, h - SBA Certified HUBZone firm
          </p>
          <div class="usa-card" [hidden]="!showBody">
            <app-user-pref-body [screenName]="this.screenName" (updateTable)="updateListPrefs($event)">
            </app-user-pref-body>
          </div>
        </div>
      }
    </div>
  </div>
  @if (hhgRateQueryResults && (hhgRateQueryResults.length > 0)) {
    <div class="grid-row grid-gap padding-y-2">
      <div class="grid-col-12">
        <ul class="usa-button-group">
          @if (!showBody) {
            <li class="usa-button-group__item">
              <button type="button" class="usa-button usa-button--hover" (click)="gotoUserPrefs()">Set data view
              preferences</button>
            </li>
          }
          @if (showBody) {
            <li class="usa-button-group__item">
              <button type="button" class="usa-button usa-button--hover" (click)="closeUserPrefs()">Close data view
              preferences</button>
            </li>
          }
          <li class="usa-button-group__item">
            <button type="button" class="usa-button usa-button--base usa-button--hover" (click)="onBtPrint()">Print Results</button>
          </li>
          <li class="usa-button-group__item">
            <button type="button" class="usa-button" (click)="onFileDownload()">Export to Excel</button>
          </li>
          <li class="usa-button-group__item">
            <button type="button" class="usa-button" (click)="onBtExport()">Export to CSV</button>
          </li>
          <li class="usa-button-group__item">
            <button type="button" class="usa-button" (click)="uabCalculator()">UAB Cost Calculator</button>
          </li>
          <li class="usa-button-group__item">
            <button type="button" class="usa-button" (click)="tspStatusPortal()">HHG TSPs in Temp Non-Use</button>
          </li>
        </ul>
      </div>
    </div>
  }
</div>
@if (hhgRateQueryResults && (hhgRateQueryResults.length > 0)) {
  <div >
    <ag-grid-angular id="myGrid" class="ag-theme-alpine hhg-results-height"
      [gridOptions]="hhgRateQueryResultsGridOptions" style="width: 100%; height: 400px;"
      [rowData]="hhgRateQueryResults" [columnDefs]="columnDefs" [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      [defaultExportParams]="defaultExportParams" [suppressDragLeaveHidesColumns]="true"
      ag-grid-resize>
    </ag-grid-angular>
  </div>
}
